import { render, staticRenderFns } from "./footerBottom.vue?vue&type=template&id=0e773b3c"
import script from "./footerBottom.vue?vue&type=script&lang=js"
export * from "./footerBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports